import { createMemoStyles, withNested, withSpacing, clsx, safeRest } from '@wds/utils';
import React from 'react';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var useStyles$6 = createMemoStyles(function (_a) {
  var spacing = _a.spacing,
    radius = _a.radius,
    palette = _a.palette,
    type = _a.type;
  var card = {
    padding: spacing[5],
    bgColor: palette.background.light
  };
  return {
    wrenchCard: function (_a) {
      var interactive = _a.interactive;
      return __assign({
        display: 'inline-flex',
        flexDirection: 'column',
        overflow: 'hidden',
        cursor: interactive ? 'pointer' : null,
        maxWidth: '368px',
        padding: [spacing[5]],
        backgroundColor: card.bgColor,
        borderRadius: radius.medium,
        border: '2px solid transparent',
        boxShadow: '0 0 0 2px #EDEEEE',
        fontFamily: type.fontFamily.base,
        fontSize: type.fontSize.body,
        '-webkit-font-smoothing': 'antialiased',
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        boxSizing: 'border-box'
      }, interactive && {
        '&:hover': {
          borderColor: 'transparent',
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.14)'
        },
        '&:focus': {
          borderColor: '#d0d2d3',
          boxShadow: 'none'
        },
        '&:active': {
          borderColor: '#d0d2d3',
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.14)'
        }
      });
    }
  };
});
var useStyles$5 = createMemoStyles(function (theme) {
  var spacing = theme.spacing;
  return {
    wrenchCardGrid: {
      display: 'grid',
      gap: spacing[5],
      gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))'
    }
  };
});
var CardGrid = function (_a) {
  var children = _a.children;
  var wrenchCardGrid = useStyles$5().wrenchCardGrid;
  return React.createElement("div", {
    className: wrenchCardGrid
  }, children);
};
CardGrid.displayName = 'CardGrid';
var useStyles$4 = createMemoStyles(function (theme) {
  var spacing = theme.spacing;
  return {
    wrenchCardPreview: function (_a) {
      var padding = _a.padding;
      return {
        margin: padding ? "0 0 0 0" : "-".concat(spacing[5], "px -").concat(spacing[5], "px 0 -").concat(spacing[5], "px")
      };
    }
  };
});
var CardPreview = function (_a) {
  var children = _a.children,
    _b = _a.padding,
    padding = _b === void 0 ? true : _b;
  var wrenchCardPreview = useStyles$4({
    padding: padding
  }).wrenchCardPreview;
  return React.createElement("div", {
    className: wrenchCardPreview
  }, children);
};
CardPreview.displayName = 'CardPreview';
var useStyles$3 = createMemoStyles(function (theme) {
  var spacing = theme.spacing;
  return {
    wrenchCardToolbar: {
      marginBottom: spacing[5],
      minWidth: '192px'
    }
  };
});
var CardToolbar = function (_a) {
  var children = _a.children;
  var wrenchCardToolbar = useStyles$3().wrenchCardToolbar;
  return React.createElement("div", {
    className: wrenchCardToolbar
  }, children);
};
CardToolbar.displayName = 'CardToolbar';
var useStyles$2 = createMemoStyles(function (theme) {
  var spacing = theme.spacing;
  return {
    wrenchCardHeader: {
      marginBottom: spacing[5],
      minWidth: '192px'
    }
  };
});
var CardHeader = function (_a) {
  var children = _a.children;
  var wrenchCardHeader = useStyles$2().wrenchCardHeader;
  return React.createElement("header", {
    className: wrenchCardHeader
  }, children);
};
CardHeader.displayName = 'CardHeader';
var useStyles$1 = createMemoStyles(function (theme) {
  return {
    wrenchCardBody: {
      margin: 'auto 0',
      minWidth: '192px'
    }
  };
});
var CardBody = function (_a) {
  var children = _a.children;
  var wrenchCardBody = useStyles$1().wrenchCardBody;
  return React.createElement("main", {
    className: wrenchCardBody
  }, children);
};
CardBody.displayName = 'CardBody';
var useStyles = createMemoStyles(function (theme) {
  var spacing = theme.spacing;
  return {
    wrenchCardFooter: {
      marginTop: spacing[5],
      minWidth: '192px'
    }
  };
});
var CardFooter = function (_a) {
  var children = _a.children;
  var wrenchCardFooter = useStyles().wrenchCardFooter;
  return React.createElement("footer", {
    className: wrenchCardFooter
  }, children);
};
CardFooter.displayName = 'CardFooter';
var Card = function (_a) {
  var children = _a.children,
    _b = _a.interactive,
    interactive = _b === void 0 ? true : _b,
    _c = _a.spacingClass,
    spacingClass = _c === void 0 ? undefined : _c,
    _d = _a.onClick,
    onClick = _d === void 0 ? undefined : _d,
    _e = _a.href,
    href = _e === void 0 ? undefined : _e,
    rest = __rest(_a, ["children", "interactive", "spacingClass", "onClick", "href"]);
  var wrenchCard = useStyles$6({
    interactive: interactive
  }).wrenchCard;
  var wrenchCardWrapper = clsx(wrenchCard, spacingClass);
  return React.createElement(React.Fragment, null, !onClick && !href && React.createElement("div", __assign({
    className: wrenchCardWrapper
  }, safeRest(rest)), children), interactive && href && !onClick && React.createElement("a", __assign({
    href: href,
    className: wrenchCardWrapper
  }, safeRest(rest)), children), interactive && onClick && !href && React.createElement("div", __assign({
    className: wrenchCardWrapper,
    onClick: onClick,
    role: interactive ? 'button' : undefined,
    tabIndex: interactive ? 0 : undefined,
    onKeyDown: interactive ? onClick : undefined
  }, safeRest(rest)), children));
};
var CardWithSpacing = withNested(withSpacing(Card), {
  Grid: CardGrid,
  Header: CardHeader,
  Preview: CardPreview,
  Toolbar: CardToolbar,
  Body: CardBody,
  Footer: CardFooter
});
export { CardWithSpacing as Card };